import React, { Component } from 'react'
import { observer } from 'mobx-react'

import i18n from 'i18next'
import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'
import Checkbox from '../../form/Checkbox'

@observer
class AdvancedSlideModalConfig extends Component {
    render() {
        const {
            addSlideConfig,
        } = this.props
        const { presentationStore } = this.props
        const advancedOptions = presentationStore.getAdvancedSlideOptions()

        return (
            <Modal
                show={presentationStore.showAdvancedSlidesModal}
                onClose={presentationStore.toggleAdvancedSlidesModal}
            >
                <div className="uc-modal__header">
                    <h2>{i18n.t('presentation.modal.advanced.title')}</h2>
                    <p className="uc-modal__desc">{i18n.t('presentation.modal.advanced.desc')}</p>
                </div>
                <div className="check-grp">
                    <label className="check-grp-label">
                        {i18n.t('presentation.modal.advanced.checkbox-grp.desc')}
                    </label>
                    <div className="check-grp-wrapper">
                        {advancedOptions.length > 0
                            ? advancedOptions.map((option) => (
                                <div
                                    className="checkbox-icon"
                                    key={option.name}
                                >
                                    <Checkbox
                                        onBlur={presentationStore.handleAdvancedModalClick}
                                        name={option.name}
                                        className="exploriNativeCheckbox"
                                        label={option.label}
                                        checked={presentationStore.advancedSlidesItems.has(option.name)}
                                    />
                                </div>
                            ))
                            : (
                                <div className="no-options">
                                    <p>{i18n.t('presentation.noAdvancedSlides')}</p>
                                </div>
                            )}
                    </div>
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        onClick={presentationStore.toggleAdvancedSlidesModal}
                        cssClass="tertiary uper-panel-button"
                    >
                        {i18n.t('close')}
                    </Button>
                    <Button
                        onClick={() => {
                            addSlideConfig()
                            presentationStore.toggleAdvancedSlidesModal()
                        }}
                        cssClass="primary uper-panel-button"
                    >
                        {' '}
                        {i18n.t('save')}
                    </Button>
                </div>

            </Modal>
        )
    }
}

export default AdvancedSlideModalConfig
